import {axiosGet} from "../../../common/Helper/AxiosHelper";
import {TENANT_BASE_URL} from "../../../common/Config/UrlHelper";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import {formatDateToLocal} from "../../../common/Helper/Support/DateTimeHelper";
import {HotelFilterMixin} from "./FilterMixin";
import HelperMixin from "../../../common/Mixin/Global/HelperMixin";

export default {
    mixins: [HelperMixin, DatatableHelperMixin, HotelFilterMixin],
    data() {
        return {
            options: {
                name             : this.$t('achievement'),
                url              : `${TENANT_BASE_URL}app/hotel/achievement`,
                preserveState    : true,
                showHeader       : true,
                tableShadow      : false,
                tablePaddingClass: 'pt-primary',
                columns          : [
                    {
                        title    : this.$t('actions'),
                        type     : 'action',
                        key      : 'id',
                        isVisible: true
                    },
                    {
                        title    : this.$t('hotel'),
                        type     : 'custom-html',
                        key      : 'hotel',
                        isVisible: true,
                        modifier : (value) => value.name
                    },
                    {
                        title    : this.$t('floor'),
                        type     : 'text',
                        key      : 'floor',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('categories'),
                        type     : 'custom-html',
                        key      : 'categories',
                        isVisible: true,
                        modifier : (categories) => {
                            return categories ? categories.map(e => e.title).join(', ') : ''
                        }
                    },
                    {
                        title        : this.$t('document'),
                        type         : 'component',
                        key          : 'files',
                        isVisible    : true,
                        componentName: 'app-file-preview-group',
                        data         : {
                            label     : this.$t('document'),
                            modalTitle: this.$t('document'),
                            emptyText : '-'
                        }
                    },
                    {
                        title    : this.$t('date'),
                        type     : 'custom-html',
                        key      : 'date',
                        isVisible: true,
                        modifier : (value) => value ? formatDateToLocal(value) : 'N/A'
                    },
                    {
                        title    : this.$t('created'),
                        type     : 'custom-html',
                        key      : 'created_at',
                        isVisible: true,
                        modifier : (value) => value ? formatDateToLocal(value) : 'N/A'
                    },
                ],
                filters          : [
                    {
                        title         : this.$t('hotel'),
                        type          : "multi-select-filter",
                        key           : "hotels",
                        option        : [],
                        listValueField: 'name',
                        permission    : !!this.$can('view_hotel_list')
                    },
                    {
                        title         : this.$t('floor'),
                        type          : "multi-select-filter",
                        key           : "floor",
                        option        : [],
                        listValueField: 'name',
                        permission    : !!this.$can('view_hotel_room')
                    },
                    {
                        title         : this.$t('categories'),
                        type          : "multi-select-filter",
                        key           : "categories",
                        option        : [],
                        listValueField: 'title',
                        permission    : !!this.$can('view_hotel_achievement')
                    },
                    {
                        title : this.$t('date'),
                        type  : "range-picker",
                        key   : "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                ],
                paginationType   : "pagination",
                responsive       : true,
                rowLimit         : 10,
                showAction       : true,
                orderBy          : 'desc',
                actionType       : 'dropdown',
                actions          : [
                    {
                        title   : this.$t('edit'),
                        icon    : 'edit',
                        type    : 'modal',
                        modifier: row => this.$can('update_hotel_achievement')
                    },
                    {
                        title    : this.$t('delete'),
                        icon     : 'trash-2',
                        type     : 'modal',
                        component: 'app-confirmation-modal',
                        modalId  : 'app-confirmation-modal',
                        url      : `${TENANT_BASE_URL}app/hotel/achievement/`,
                        name     : 'delete',
                        modifier : row => this.$can('update_hotel_achievement')
                    }
                ],
            }
        }
    },
    mounted() {
        this.hydrateDependentFiltersFromUrl();
        window.addEventListener('popstate', this.hydrateDependentFiltersFromUrl);
    },
    beforeDestroy() {
        window.removeEventListener('popstate', this.hydrateDependentFiltersFromUrl);
    },
    methods: {
        hydrateDependentFiltersFromUrl() {
            const query = new URLSearchParams(window.location.search);

            this.getFilterValues({
                hotels: query.get('hotels') || ''
            });
        },
        normalizeFloorOptions(options = []) {
            return options.map(item => {
                const normalizedId = Number(item.id);

                return {
                    ...item,
                    id: Number.isNaN(normalizedId) ? item.id : normalizedId,
                };
            });
        },
        getFilterValues(value) {
            const roomFilter     = this.options.filters.find(item => item.key === 'floor');
            const categoryFilter = this.options.filters.find(item => item.key === 'categories');

            axiosGet(`${TENANT_BASE_URL}app/hotel/achievement-category?per_page=0`)
                .then(({data}) => categoryFilter.option = data)
                .catch(error => this.$toastr.e(error.response.data.message))

            if (value.hotels) {
                axiosGet(`${TENANT_BASE_URL}selectable/hotel/room?hotel_id=${value.hotels}&group=floor&format=floor`)
                    .then(({data}) => {
                        roomFilter.option = this.normalizeFloorOptions(data);
                    })
                    .catch(error => this.$toastr.e(error.response.data.message))
            } else {
                roomFilter.option = []
            }
        },
    },
}
